import React, { useMemo } from "react";

import type { ResolvedMessageBoxDeviceConfig } from "@intelligems/ig-types";

import { MessageBoxViewProps } from "../../MessageBoxView";
import { MessageBoxContextType } from "../../MessageBoxView/types";

import { MessageBoxContext } from "./MessageBoxContext";

export interface MessageBoxContextProviderProps extends MessageBoxViewProps {
  widget: ResolvedMessageBoxDeviceConfig;
  hasMediaQuery?: boolean;
  children: React.ReactNode;
}

export const MessageBoxContextProvider = (
  props: MessageBoxContextProviderProps
) => {
  const { isFe, config, widget, onClose, visible, hasMediaQuery, children } =
    props;
  const value = useMemo<MessageBoxContextType>(
    () => ({
      isFe,
      config,
      widget,
      onClose,
      visible,
      hasMediaQuery,
    }),
    [config, isFe, widget, onClose, visible, hasMediaQuery]
  );

  return (
    <MessageBoxContext.Provider value={value}>
      {children}
    </MessageBoxContext.Provider>
  );
};
